/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DataHubStatus = {
    NotSpecified: 'NotSpecified',
    Rejected: 'Rejected',
    Confirmed: 'Confirmed',
    Pending: 'Pending',
    Obsolete: 'Obsolete',
    PendingJob: 'PendingJob',
    NotApplicable: 'NotApplicable',
} as const;
export type DataHubStatus = typeof DataHubStatus[keyof typeof DataHubStatus];

